import React from "react";
import "./App.css";
import { Provider } from "react-redux";
import store from "@diditusa/shared/store";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/home";
import AppContainer from "./components/AppContainer/appContainer";
import Companies from "./pages/Companies/companies";
import CompaniesCreate from "./pages/Companies/companies.create";
import Jobs from "./pages/Jobs/jobs";
import JobsCreate from "./pages/Jobs/jobs.create";
import CompaniesManage from "./pages/Companies/companies.manage";
import Users from "./pages/Users/users";
import CompaniesDetails from "./pages/Companies/companies.details";
import UserDetails from "./pages/Users/users.details";
import JobDetails from "./pages/Jobs/jobs.details";
import Products from "./pages/Products/Products";
import NewProduct from "./pages/Products/NewProduct";
import ProductDetails from "./pages/Products/ProductDetails";
import AgentProfileEdit from "./pages/Companies/companies.employee.details";
import { JobStatus } from "@diditusa/shared/types/jobTypes";
import AffiliatePage from "./pages/Affiliates/affiliates";
import AffiliateDetailsPage from "./pages/Affiliates/affiliateDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Provider store={store}>
          <Routes>
            <Route path="/" element={<AppContainer />}>
              <Route index element={<Home />} />
              <Route path="/companies" element={<Companies />} />
              <Route path="/companies/create" element={<CompaniesCreate />} />
              <Route
                path="/companies/:companyId"
                element={<CompaniesDetails />}
              />
              <Route
                path="/companies/:companyId/agents/:agentId/edit"
                element={<AgentProfileEdit />}
              />

              <Route path="/jobs" element={<Jobs />} />
              <Route
                path="/jobs/completed"
                element={
                  <Jobs
                    statuses={[
                      JobStatus.COMPLETED,
                      JobStatus.AWAITING_COMPLETION_CONFIRMATION,
                    ]}
                  />
                }
              />
              <Route
                path="/jobs/ready"
                element={<Jobs statuses={[JobStatus.READY_TO_START]} />}
              />
              <Route
                path="/jobs/abandoned"
                element={
                  <Jobs
                    statuses={[JobStatus.AWAITING_PAYMENT, JobStatus.CANCELED]}
                  />
                }
              />
              <Route path="/jobs/create" element={<JobsCreate />} />
              <Route path="/jobs/:jobId" element={<JobDetails />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/:userId" element={<UserDetails />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/new" element={<NewProduct />} />
              <Route path="/products/:productId" element={<ProductDetails />} />
              <Route path="/affiliates" element={<AffiliatePage />} />
              <Route
                path="/affiliates/:affiliateId"
                element={<AffiliateDetailsPage />}
              />

              {/* //Make in dev only */}
            </Route>
          </Routes>
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
